import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import parsePostContent from '../../common/helpers/parsePostContent';
/** System post for "turn time expired". Type: arenaBattleExpired. */
export default class ArenaBattleExpiredPost extends Component {
  view() {
    const data = parsePostContent(this.attrs.post.content());
    if (!data) return null;
    return m("div", {
      className: "ArenaFinalPost ArenaFinalPost--expired EventPost"
    }, m("div", {
      className: "ArenaFinalPost-icon"
    }, m("i", {
      className: "fas fa-trophy"
    })), m("div", {
      className: "ArenaFinalPost-body"
    }, m("div", {
      className: "ArenaFinalPost-title"
    }, data.winnerName ? app.translator.trans('forumaker-arena.forum.battle_expired.title', {
      name: m("strong", null, data.winnerName)
    }) : app.translator.trans('forumaker-arena.forum.battle_expired.title_generic')), m("div", {
      className: "ArenaFinalPost-subtitle"
    }, data.loserName ? app.translator.trans('forumaker-arena.forum.battle_expired.subtitle', {
      name: data.loserName
    }) : app.translator.trans('forumaker-arena.forum.battle_expired.subtitle_generic'))));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ArenaBattleExpiredPost', ArenaBattleExpiredPost);